import { render, staticRenderFns } from "./iconHelp.vue?vue&type=template&id=829a9d46&scoped=true&"
import script from "./iconHelp.vue?vue&type=script&lang=js&"
export * from "./iconHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829a9d46",
  null
  
)

export default component.exports